import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import MarkdownWithPoints from "../../../components/common/markdown/MarkdownWithPoints";
import Markdown from "react-markdown";
import SubHeading from "../../../components/common/heading/SubHeading";
import { getClickIdByTitle } from "../../../utils/ebolaClickIdProvider";
const Airport = ({ data, keyword }) => {
  return (
    <section id="airport-section">
      {data?.map((section, index) => {
        const card = section?.cards_section?.[0];

        const isEven = index % 2 !== 0;

        return (
          <div
            id={
              keyword === "ebola-advisory" ? card?.card_id : `airport_${index}`
            }
            key={index}
            className={`${isEven ? "bg-[#E6EAEF]" : ""
              } pt-[4.34vh] pb-[5.34vh]`}
          >
            <div className="container">
              <div className="flex justify-center lg:pb-[1.5vw] pb-[3vw]">
                <div className="lg:w-fit text-center border-b-[0.15vw] border-[#F77D0D]">
                  {/* <SubHeading
                    text={section.heading}
                    textColor={section.heading ? section.heading : "#002C62"}
                  /> */}
                  <h2
                    className="font-redhatMedium lg:text-[2.3vw] md:text-[5vw] text-[5.5vw] text-center"
                    style={{
                      color: "#002C62",
                    }}
                  >
                    {section.heading}
                  </h2>
                </div>
              </div>
              <div
                className={` mx-auto px-4 md:flex md:gap-[3vw] ${isEven ? "flex-row-reverse" : ""
                  }`}
              >
                <div className="md:w-1/2 mb-8 md:mb-0 ">
                  {/* <ImageProvider
                    className=" mx-auto md:mx-0 md:ml-0 airportImg"
                    Image={card?.card_image}
                    //alt={card?.card_image?.alternativeText}
                    alt=""
                    aria-hidden="true"
                    tailwindStyle="min-h-[22.64vw] w-full object-cover airportImg"
                  /> */}
                  <img
                    src={card?.card_image?.url}
                    alt=""
                    aria-hidden="true"
                    className="lg:h-[23vw] w-full object-fill airportImg"
                  />
                </div>

                <div className="md:w-1/2 my-auto text-center md:text-left">
                  <div className="w-fit lg:border-b-[0.2vw] border-b-[0.4vw] border-[#E88334]">
                    <h3 className="text-primary text-[3.5vw] md:text-[2vw] font-redhatMedium leading-tight">
                      {card?.heading}
                    </h3>
                  </div>

                  <div className="space-y-4 markdown_list text-primary text-[2.9vw] md:text-[1.19vw] text-center md:text-left font-redhatRegular lg:mt-[1vw] mt-[2vw]">
                    {/* <MarkdownWithPoints
                      data={card?.description?.data?.description}
                      tailwindStyle="custom-markdown"
                    /> */}
                    <Markdown
                      components={{
                        a: ({ href, children, ...props }) => (
                          <a
                            aria-label={`Read more about ${card?.heading}`}
                            href={href}
                            className="underline text-[#23406e]"
                            {...props}
                          >
                            {children}
                          </a>
                        ),
                      }}
                    >
                      {card?.description?.data?.description}
                    </Markdown>
                  </div>

                  {card?.card_button?.label && (
                    <div className="mt-6 airportBtns">
                      <a
                        id={getClickIdByTitle(card?.card_button?.label)}
                        aria-label={`${card.card_button.label} about ${card?.heading}`}
                        href={card.card_button.href || "#"}
                        target={
                          index === 1 ||
                            card.card_button.label === "Fill You Form"
                            ? "_blank"
                            : ""
                        }
                        className="inline-block px-[2vw] xl:px-[0.5vw] py-[2vw] xl:py-[0.5vw] rounded-md transition md:text-[1.2vw] text-[3.29vw] font-redhatMedium"
                        style={{
                          backgroundColor:
                            card.card_button.bg_color || "#0A2540",
                          color: card.card_button.label_color || "#FFFFFF",
                        }}
                      >
                        {card.card_button.label}{" "}
                        <span className="inline-block ml-[0.5vw]">
                          <img
                            className=""
                            src={card?.card_button?.icon?.url}
                            //alt={card.card_button.icon?.alternativeText}
                            aria-hidden="true"
                          />
                        </span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Airport;
